import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { SvelteComponent, init, safe_not_equal, create_component, mount_component, transition_in, transition_out, destroy_component, create_slot, space, element, text, attr, insert, append, set_data, update_slot_base, get_all_dirty_from_scope, get_slot_changes, detach } from '../../node_modules/svelte/internal/index.mjs.js';
import LiOrDiv from '../../core/partials/LiOrDiv.svelte.js';
import T3Config from '../../core/partials/T3Config.svelte.js';
import WireframeWrapper from '../../core/partials/WireframeWrapper.svelte.js';
import { l10n } from '../../services/template-utils/helpers.js';

const get_extended_format_slot_changes = function (dirty) {
  return {};
};
const get_extended_format_slot_context = function (ctx) {
  return {};
};

// (59:6) { #if !programmaticWireframes }
function create_if_block(ctx) {
  let div;
  return {
    c() {
      div = element("div");
      attr(div, "class", "ad-wireframe-programmatic");
    },
    m(target, anchor) {
      insert(target, div, anchor);
    },
    d(detaching) {
      if (detaching) detach(div);
    }
  };
}

// (52:2) <LiOrDiv { tag } { attributes }>
function create_default_slot_1(ctx) {
  let t3config;
  let t0;
  let div1;
  let h2;
  let t1_value = ( /*customDisclosure*/ctx[4] || l10n('ADVERTISEMENT', 'Advertisement')) + "";
  let t1;
  let t2;
  let t3;
  let div0;
  let div0_id_value;
  let div0_class_value;
  let t4;
  let div1_id_value;
  let current;
  t3config = new T3Config({
    props: {
      config: /*slot*/ctx[3]
    }
  });
  let if_block = ! /*programmaticWireframes*/ctx[0] && create_if_block();
  const extended_format_slot_template = /*#slots*/ctx[15]["extended-format"];
  const extended_format_slot = create_slot(extended_format_slot_template, ctx, /*$$scope*/ctx[16], get_extended_format_slot_context);
  return {
    c() {
      create_component(t3config.$$.fragment);
      t0 = space();
      div1 = element("div");
      h2 = element("h2");
      t1 = text(t1_value);
      t2 = space();
      if (if_block) if_block.c();
      t3 = space();
      div0 = element("div");
      t4 = space();
      if (extended_format_slot) extended_format_slot.c();
      attr(h2, "class", "ad__disclosure--ex js-ad-disclosure");
      attr(div0, "id", div0_id_value = "div-gpt-ad-" + /*slot*/ctx[3].wid);
      attr(div0, "class", div0_class_value = "xs-text-center " + ( /*programmaticWireframes*/ctx[0] ? '' : 'ad-animated ad-fadedown') + " ad-slot js-ad-slot js-ad-slot-" + /*slot*/ctx[3].wid);
      attr(div1, "id", div1_id_value = "bf-item-" + /*slot*/ctx[3].wid + "-1");
    },
    m(target, anchor) {
      mount_component(t3config, target, anchor);
      insert(target, t0, anchor);
      insert(target, div1, anchor);
      append(div1, h2);
      append(h2, t1);
      append(div1, t2);
      if (if_block) if_block.m(div1, null);
      append(div1, t3);
      append(div1, div0);
      append(div1, t4);
      if (extended_format_slot) {
        extended_format_slot.m(div1, null);
      }
      current = true;
    },
    p(ctx, dirty) {
      const t3config_changes = {};
      if (dirty & /*slot*/8) t3config_changes.config = /*slot*/ctx[3];
      t3config.$set(t3config_changes);
      if ((!current || dirty & /*customDisclosure*/16) && t1_value !== (t1_value = ( /*customDisclosure*/ctx[4] || l10n('ADVERTISEMENT', 'Advertisement')) + "")) set_data(t1, t1_value);
      if (! /*programmaticWireframes*/ctx[0]) {
        if (if_block) ; else {
          if_block = create_if_block();
          if_block.c();
          if_block.m(div1, t3);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
      if (!current || dirty & /*slot*/8 && div0_id_value !== (div0_id_value = "div-gpt-ad-" + /*slot*/ctx[3].wid)) {
        attr(div0, "id", div0_id_value);
      }
      if (!current || dirty & /*programmaticWireframes, slot*/9 && div0_class_value !== (div0_class_value = "xs-text-center " + ( /*programmaticWireframes*/ctx[0] ? '' : 'ad-animated ad-fadedown') + " ad-slot js-ad-slot js-ad-slot-" + /*slot*/ctx[3].wid)) {
        attr(div0, "class", div0_class_value);
      }
      if (extended_format_slot) {
        if (extended_format_slot.p && (!current || dirty & /*$$scope*/65536)) {
          update_slot_base(extended_format_slot, extended_format_slot_template, ctx, /*$$scope*/ctx[16], !current ? get_all_dirty_from_scope( /*$$scope*/ctx[16]) : get_slot_changes(extended_format_slot_template, /*$$scope*/ctx[16], dirty, get_extended_format_slot_changes), get_extended_format_slot_context);
        }
      }
      if (!current || dirty & /*slot*/8 && div1_id_value !== (div1_id_value = "bf-item-" + /*slot*/ctx[3].wid + "-1")) {
        attr(div1, "id", div1_id_value);
      }
    },
    i(local) {
      if (current) return;
      transition_in(t3config.$$.fragment, local);
      transition_in(extended_format_slot, local);
      current = true;
    },
    o(local) {
      transition_out(t3config.$$.fragment, local);
      transition_out(extended_format_slot, local);
      current = false;
    },
    d(detaching) {
      destroy_component(t3config, detaching);
      if (detaching) detach(t0);
      if (detaching) detach(div1);
      if (if_block) if_block.d();
      if (extended_format_slot) extended_format_slot.d(detaching);
    }
  };
}

// (48:0) <WireframeWrapper   hasWireframe={ programmaticWireframes } width={ wireframeWidth } height={ wireframeHeight }   { isListItem } cssClasses={ wireframeClasses } >
function create_default_slot(ctx) {
  let liordiv;
  let current;
  liordiv = new LiOrDiv({
    props: {
      tag: /*tag*/ctx[7],
      attributes: /*attributes*/ctx[8],
      $$slots: {
        default: [create_default_slot_1]
      },
      $$scope: {
        ctx
      }
    }
  });
  return {
    c() {
      create_component(liordiv.$$.fragment);
    },
    m(target, anchor) {
      mount_component(liordiv, target, anchor);
      current = true;
    },
    p(ctx, dirty) {
      const liordiv_changes = {};
      if (dirty & /*tag*/128) liordiv_changes.tag = /*tag*/ctx[7];
      if (dirty & /*attributes*/256) liordiv_changes.attributes = /*attributes*/ctx[8];
      if (dirty & /*$$scope, slot, programmaticWireframes, customDisclosure*/65561) {
        liordiv_changes.$$scope = {
          dirty,
          ctx
        };
      }
      liordiv.$set(liordiv_changes);
    },
    i(local) {
      if (current) return;
      transition_in(liordiv.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(liordiv.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(liordiv, detaching);
    }
  };
}
function create_fragment(ctx) {
  let wireframewrapper;
  let current;
  wireframewrapper = new WireframeWrapper({
    props: {
      hasWireframe: /*programmaticWireframes*/ctx[0],
      width: /*wireframeWidth*/ctx[1],
      height: /*wireframeHeight*/ctx[2],
      isListItem: /*isListItem*/ctx[6],
      cssClasses: /*wireframeClasses*/ctx[5],
      $$slots: {
        default: [create_default_slot]
      },
      $$scope: {
        ctx
      }
    }
  });
  return {
    c() {
      create_component(wireframewrapper.$$.fragment);
    },
    m(target, anchor) {
      mount_component(wireframewrapper, target, anchor);
      current = true;
    },
    p(ctx, _ref) {
      let [dirty] = _ref;
      const wireframewrapper_changes = {};
      if (dirty & /*programmaticWireframes*/1) wireframewrapper_changes.hasWireframe = /*programmaticWireframes*/ctx[0];
      if (dirty & /*wireframeWidth*/2) wireframewrapper_changes.width = /*wireframeWidth*/ctx[1];
      if (dirty & /*wireframeHeight*/4) wireframewrapper_changes.height = /*wireframeHeight*/ctx[2];
      if (dirty & /*isListItem*/64) wireframewrapper_changes.isListItem = /*isListItem*/ctx[6];
      if (dirty & /*wireframeClasses*/32) wireframewrapper_changes.cssClasses = /*wireframeClasses*/ctx[5];
      if (dirty & /*$$scope, tag, attributes, slot, programmaticWireframes, customDisclosure*/65945) {
        wireframewrapper_changes.$$scope = {
          dirty,
          ctx
        };
      }
      wireframewrapper.$set(wireframewrapper_changes);
    },
    i(local) {
      if (current) return;
      transition_in(wireframewrapper.$$.fragment, local);
      current = true;
    },
    o(local) {
      transition_out(wireframewrapper.$$.fragment, local);
      current = false;
    },
    d(detaching) {
      destroy_component(wireframewrapper, detaching);
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  let {
    $$slots: slots = {},
    $$scope
  } = $$props;
  let {
    slot
  } = $$props;
  let {
    customDisclosure
  } = $$props;
  let {
    programmaticWireframes
  } = $$props;
  let {
    programmatic_wireframes
  } = $$props;
  let {
    wireframeWidth
  } = $$props;
  let {
    wireframe_width
  } = $$props;
  let {
    wireframeHeight
  } = $$props;
  let {
    wireframe_height
  } = $$props;
  let {
    wireframeClasses
  } = $$props;
  let {
    isListItem = false
  } = $$props;
  let {
    t3ModuleName = 'ad-ex'
  } = $$props;
  let {
    cssClasses = function (defaultClasses) {
      return defaultClasses;
    }
  } = $$props;
  let {
    position
  } = $$props;
  let tag;
  let attributes;
  $$self.$$set = function ($$props) {
    if ('slot' in $$props) $$invalidate(3, slot = $$props.slot);
    if ('customDisclosure' in $$props) $$invalidate(4, customDisclosure = $$props.customDisclosure);
    if ('programmaticWireframes' in $$props) $$invalidate(0, programmaticWireframes = $$props.programmaticWireframes);
    if ('programmatic_wireframes' in $$props) $$invalidate(9, programmatic_wireframes = $$props.programmatic_wireframes);
    if ('wireframeWidth' in $$props) $$invalidate(1, wireframeWidth = $$props.wireframeWidth);
    if ('wireframe_width' in $$props) $$invalidate(10, wireframe_width = $$props.wireframe_width);
    if ('wireframeHeight' in $$props) $$invalidate(2, wireframeHeight = $$props.wireframeHeight);
    if ('wireframe_height' in $$props) $$invalidate(11, wireframe_height = $$props.wireframe_height);
    if ('wireframeClasses' in $$props) $$invalidate(5, wireframeClasses = $$props.wireframeClasses);
    if ('isListItem' in $$props) $$invalidate(6, isListItem = $$props.isListItem);
    if ('t3ModuleName' in $$props) $$invalidate(12, t3ModuleName = $$props.t3ModuleName);
    if ('cssClasses' in $$props) $$invalidate(13, cssClasses = $$props.cssClasses);
    if ('position' in $$props) $$invalidate(14, position = $$props.position);
    if ('$$scope' in $$props) $$invalidate(16, $$scope = $$props.$$scope);
  };
  $$self.$$.update = function () {
    if ($$self.$$.dirty & /*programmaticWireframes, programmatic_wireframes, wireframeWidth, wireframe_width, wireframeHeight, wireframe_height*/3591) {
      // support both snake_case (from `bf_ads`) and camelCase (from `ads_component_ui`) wireframe props for now
      {
        $$invalidate(0, programmaticWireframes = programmaticWireframes || programmatic_wireframes);
        $$invalidate(1, wireframeWidth = wireframeWidth || wireframe_width);
        $$invalidate(2, wireframeHeight = wireframeHeight || wireframe_height);
      }
    }
    if ($$self.$$.dirty & /*isListItem, programmaticWireframes, slot, t3ModuleName, cssClasses, position*/28745) {
      {
        $$invalidate(7, tag = isListItem && !programmaticWireframes ? 'li' : 'div');
        $$invalidate(8, attributes = {
          'id': "BF_WIDGET_".concat(slot.wid),
          'data-module': t3ModuleName,
          'class': cssClasses('xs-relative ad-ex')
        });
        if (position) {
          $$invalidate(8, attributes.position = position, attributes);
        }
      }
    }
  };
  return [programmaticWireframes, wireframeWidth, wireframeHeight, slot, customDisclosure, wireframeClasses, isListItem, tag, attributes, programmatic_wireframes, wireframe_width, wireframe_height, t3ModuleName, cssClasses, position, slots, $$scope];
}
let Ex = /*#__PURE__*/function (_SvelteComponent) {
  function Ex(options) {
    var _this;
    _classCallCheck(this, Ex);
    _this = _callSuper(this, Ex);
    init(_this, options, instance, create_fragment, safe_not_equal, {
      slot: 3,
      customDisclosure: 4,
      programmaticWireframes: 0,
      programmatic_wireframes: 9,
      wireframeWidth: 1,
      wireframe_width: 10,
      wireframeHeight: 2,
      wireframe_height: 11,
      wireframeClasses: 5,
      isListItem: 6,
      t3ModuleName: 12,
      cssClasses: 13,
      position: 14
    });
    return _this;
  }
  _inherits(Ex, _SvelteComponent);
  return _createClass(Ex);
}(SvelteComponent);

export { Ex as default };
